import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../../common/filterCompany/useSettingParams'
import { HighlightInfo } from '../../../common/highlightInfo'
import { PopupCompanyList } from '../../../common/popupCompanyList'
import {
  changeDisplayType,
  handleScrollActiveRow,
  selectDisplayType,
  selectHightLight,
  selectLoading,
  selectRawTotalCompany,
  selectTotalCompany,
} from '../../store/slice'
import { postHightLight, postTotalCompany } from '../../store/thunk'
import { HIGH_LIGHT_RATIO, SCROLL_OPTIONS } from '../config'
import { handleHightLightData } from './helper'
import usePopupData from './usePopupData'

const HIGHT_LIGHT_HEIGHT = 67

const HightLight = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()
  const [isShowPopup, setIsShowPopup] = useState(false)

  const displayType = useSelector(selectDisplayType)
  const totalCompanyLoading = useSelector(
    selectLoading(postTotalCompany.typePrefix),
  )
  const highLightLoading = useSelector(selectLoading(postHightLight.typePrefix))
  const totalCompanyData = useSelector(selectTotalCompany)
  const rawTotalCompany = useSelector(selectRawTotalCompany)
  const hightLight = useSelector(selectHightLight)
  const locale = useSelector((state) => state.i18n.locale)

  const {
    getListCompany,
    setPage,
    setPageSize,
    popupLoading,
    selectIds,
    selectDataFromRedux,
    selectPaginationInfo,
  } = usePopupData()

  const scrollActiveRow = (params) => () => {
    dispatch(handleScrollActiveRow(params))
  }

  const showListCompany = () => {
    setIsShowPopup(true)
  }

  const highlightsData = useMemo(() => {
    if (totalCompanyLoading || highLightLoading) return []

    return handleHightLightData(
      displayType,
      totalCompanyData,
      hightLight,
      SCROLL_OPTIONS[displayType],
      scrollActiveRow,
      showListCompany,
      locale,
    )
  }, [totalCompanyLoading, highLightLoading])

  useEffect(() => {
    if (!settingParams) return

    dispatch(
      postTotalCompany({
        ...settingParams,
        companyType: displayType,
      }),
    )
  }, [settingParams, displayType])

  useEffect(() => {
    if (!settingParams) return

    dispatch(
      postHightLight({
        ...settingParams,
        companyType: displayType,
        ratiosSelected: HIGH_LIGHT_RATIO[displayType],
      }),
    )
  }, [displayType, locale, settingParams])

  useEffect(() => {
    if (
      !rawTotalCompany.length ||
      rawTotalCompany.every((item) => item.totalCompanies === 0)
    )
      return

    const currentType = rawTotalCompany.find(
      (item) => item.companyType === displayType,
    )
    if (!currentType || currentType.totalCompanies !== 0) return
    const firstItemHasCompany = rawTotalCompany.find(
      (item) => item.totalCompanies > 0,
    )
    dispatch(changeDisplayType(firstItemHasCompany.companyType))
  }, [rawTotalCompany])

  return (
    <div>
      <HighlightInfo
        highlights={highlightsData}
        isLoading={totalCompanyLoading || highLightLoading}
        containerStyle={{ minHeight: HIGHT_LIGHT_HEIGHT }}
      />
      {isShowPopup && (
        <PopupCompanyList
          isShowPopup={isShowPopup}
          setIsShowPopup={setIsShowPopup}
          isLoading={popupLoading}
          selectIds={selectIds}
          selectDataFromRedux={selectDataFromRedux}
          getListCompany={getListCompany}
          selectPaginationInfo={selectPaginationInfo}
          setPage={setPage}
          setPageSize={setPageSize}
        />
      )}
    </div>
  )
}

export default HightLight
